import React from "react";
import Typography from "@material-ui/core/Typography";
import * as APIStore from "../../store/APIStore";
import Paper from '@material-ui/core/Paper';

export interface AssignedProviderDisplay {
    name: string,
    title : string
}

const AssignedProviderDisplay = (props: AssignedProviderDisplay) => {
    let { name, title } = props;
    if (!name) {
        return (<></>)
    }

    return (
        <p>{title}: <strong>{name}</strong></p>
    )
}
export default AssignedProviderDisplay;
